<template>
  <div class="group-manage conmon-top micro-page">
    <el-container>
      <!--左侧分组-->
      <el-aside
        class="left-aside-type"
        width="220px"
        style="margin-top: 24px;margin-left: 20px"
      >
        <div class="group-search">
          <el-input
            placeholder="请输入分组名称"
            v-model.trim="groupName"
            @keyup.enter.native="searchQrcodeType"
          >
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              style="cursor: pointer"
              @click="searchQrcodeType"
            ></i>
          </el-input>
        </div>
        <el-menu
          default-active="0"
          class="el-menu-vertical-demo"
          style="max-height: 850px;width:100%; border-right: none; overflow-y: auto;overflow-x:hidden;margin-bottom: 0;padding-bottom: 0"
          @open="handleOpen"
          @close="handleClose"
          text-color="#333"
          active-text-color="#333"
        >
          <el-menu-item
            :class="item.choosen ? 'getIt' : ''"
            :index="index + ''"
            v-for="(item, index) in groups"
            :key="index"
            @click="chooseTagsType(index, item)"
          >
            <div
              class="menu-btn"
              v-if="item.name !== '全部'"
            >
              <i
                      v-if="butsObj.edit_group"
                @click="editGroupTypeItem(item)"
                class="el-icon-edit"
                style="margin-right: 0"
              ></i>
              <i
                      v-if="butsObj.del_group"
                @click="deleteTagsGroupItem(item)"
                class="el-icon-close"
                style="margin-right: 0"
              ></i>
            </div>
            <span
              class="menu-title"
              :title="item.name"
            >{{ item.name }}</span>
          </el-menu-item>
          <div
                  v-if="butsObj.add_group"
            class="add-group-btn"
            @click="addGroup"
          >
            <i
              class="el-icon-circle-plus-outline"
              title="添加分组"
            ></i>
          </div>
        </el-menu>
      </el-aside>
      <!--右侧列表-->
      <div style="padding:0;width: calc(100% - 220px)">
        <div
          class="base-input ovf-hd"
          style="margin-bottom: 10px"
        >
          <el-row class="search-title">
            <el-col
              :span="4"
              class="table-title"
            >
              <i
                class="el-icon-search"
                style="font-weight: bold;"
              ></i>
              <span class="order-list-search-span">筛选查询</span>
            </el-col>
            <el-col
              :span="20"
              class="text-align-right"
            >
              <el-button
                class="search-open-close"
                type="text"
                @click="hide=!hide"
                v-show="hide"
              >收起查询</el-button>
              <el-button
                class="search-open-close"
                type="text"
                @click="hide=!hide"
                v-show="!hide"
              >展开查询</el-button>
              <i
                v-if="hide === true"
                class="el-icon-arrow-up search-open-close-i"
                @click="hide=!hide"></i>
              <i
                v-if="hide === false"
                class="el-icon-arrow-down search-open-close-i"
                @click="hide=!hide"></i>
              <el-button
                class="search-btn-new"
                type="primary"
                size="small"
                @click="searchLoad"
              >查询</el-button>
            </el-col>
          </el-row>
          <el-row
            class="search-content common-search-formtype"
            v-show="hide"
          >
            <el-col class="text-align-left common-search-formtype search-input-group">
              <el-form
                :inline="true"
                :model="searchForm"
                class="search-content-item micro-page-content-form"
                style="margin-top: 0"
                label-width="85px"
              >
                <el-form-item
                  label="搜索标签"
                  style="margin-bottom: 0;"
                >
                  <el-input
                    clearable
                    @keyup.enter.native="searchLoad"
                    placeholder="请输入标签名称"
                    v-model.trim="tagsName"
                  ></el-input>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </div>
        <el-row
          class="search-title common-table-top"
          style="padding-right:0;height:50px;"
        >
          <el-col
            :span="4"
            class="table-title"
            style="height:50px;"
          >
            <i
              class="el-icon-document"
              style="font-weight: bold;"
            ></i>
            <span>数据列表</span>
          </el-col>
          <el-col
            :span="20"
            class="text-align-right safari-input-style"
            style="height:50px"
          >
            <span style="margin-left: 20px">移到分组：</span>
            <el-select
              class="common-search-formtype"
              style="margin:0 10px 8px 0;vertical-align: middle!important;"
              v-model="tags_group"
              :disabled="checkAll"
              @change="confirmChooseGroupType"
              placeholder="请选择目标分组"
            >
              <el-option
                v-for="item in queryGroups"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-button
              class="add-btn btn-right"
              type="primary"
              size="small"
              style="margin-left: 0"
              v-if="butsObj.add"
              @click="addTagDialog = true"
            >新建标签</el-button>
          </el-col>
        </el-row>
        <!--数据列表-->
        <el-table
          v-if="showCustomer === true"
          key="tableData"
          id="tableData"
          ref="multipleTable"
          :data="tableData"
          class="table table-checkbox-style"
          @selection-change="handleSelectionChange"
          v-loading="loading"
        >
          <template slot="empty">
            <div class="newTableEmpty">暂无数据，去<span @click="addTagDialog = true">新建</span></div>
          </template>
          <el-table-column
            type="selection"
            width="50"
          >
          </el-table-column>
          <el-table-column
            width="260"
            prop="name"
            label="标签名称"
          >
          </el-table-column>
          <el-table-column
            prop="useNum"
            label="标记人数"
          >
            <template slot-scope="scope">
              <div
                class="push-page"
                @click="pushToHightSearch(scope.row)"
              >
                {{ scope.row.useNum }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="创建时间">
            <template slot-scope="scope">
              {{ scope.row.updateTime | formatDate }}
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="220"
            align="center"
          >
            <template slot-scope="scope">
              <div
                      v-if="butsObj.edit"
                class="op-link editColor"
                @click="editTagsItem(scope.row)"
              >
                编辑
              </div>
              <div
                      v-if="butsObj.del"
                class="op-link deleteColor"
                @click="deleteTagsItem(scope.row)"
              >
                删除
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div
          class="table-foot"
          style="text-align: right"
        >
          <el-pagination
            class="table-foot-pagination"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="limit"
            :current-page="page"
            layout="total, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>
    </el-container>
    <!--添加标签弹窗-->
    <el-dialog
      class="cellDialog base-dialog"
      title="新建标签"
      :visible.sync="addTagDialog"
      width="520px"
    >
      <el-form
        ref="addTagsForm"
        :model="addTagsForm"
        :rules="addTagRules"
      >
        <el-form-item
          label="所属分组:"
          :label-width="addLabelWidth"
        >
          <el-select
            v-model="addTagsForm.groupId"
            placeholder="请选择所属分组"
            clearable>
            <el-option
              v-for="item in tagsOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="标签名称:"
          :label-width="addLabelWidth"
          prop="name"
        >
          <el-input
            :maxlength="20"
            type="text"
            v-model.trim="addTagsForm.name"
            auto-complete="off"
            placeholder="输入标签标签名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
        style="margin-top: 10px"
      >
        <el-button
          class="dialog-cancel-btn"
          @click="addTagDialog = false"
          style="margin-left: 20px"
        >取 消</el-button>
        <el-button
          :disabled="btnDisabled"
          class="dialog-confirm-btn"
          type="primary"
          @click="submitAddTagsForm('addTagsForm')"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!--编辑标签弹窗-->
    <el-dialog
      class="cellDialog base-dialog"
      title="编辑标签"
      :visible.sync="editTagsDialog"
      width="520px"
    >
      <el-form
        ref="editTagsForm"
        :model="editTagsForm"
        :rules="rules"
      >
        <el-form-item
          label="所属分组:"
          :label-width="addLabelWidth"
        >
          <el-select
            v-model="editTagsForm.groupId"
            placeholder="请选择所属分组"
            clearable>
            <el-option
              v-for="item in tagsOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="标签名称:"
          :label-width="addLabelWidth"
          prop="name"
        >
          <el-input
            :maxlength="20"
            type="text"
            v-model.trim="editTagsForm.name"
            auto-complete="off"
            placeholder="输入标签标签名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
        style="margin-top: 10px"
      >
        <el-button
          class="dialog-cancel-btn"
          @click="editTagsDialog = false"
          style="margin-left: 20px"
        >取 消</el-button>
        <el-button
          :disabled="btnDisabled"
          class="dialog-confirm-btn"
          type="primary"
          @click="submitEditTagsForm('editTagsForm')"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!--添加标签分组弹窗-->
    <el-dialog
      class="cellDialog base-dialog"
      title="创建标签分组"
      :visible.sync="addTagGroupDialog"
      width="520px"
    >
      <el-form
        ref="addTagsGroupForm"
        :model="addTagsGroupForm"
        :rules="rules"
      >
        <el-form-item
          label="分组名称:"
          :label-width="addLabelWidth"
          prop="name"
        >
          <el-input
            :maxlength="20"
            type="text"
            v-model.trim="addTagsGroupForm.name"
            auto-complete="off"
            placeholder="输入标签分组名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
        style="margin-top: 10px"
      >
        <el-button
          class="dialog-cancel-btn"
          @click="addTagGroupDialog = false"
          style="margin-left: 20px"
        >取 消</el-button>
        <el-button
          :disabled="btnDisabled"
          class="dialog-confirm-btn"
          type="primary"
          @click="submitAddTagsGroupForm('addTagsGroupForm')"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!--编辑标签分组弹窗-->
    <el-dialog
      class="cellDialog base-dialog"
      title="编辑标签分组"
      :visible.sync="editTagsGroupDialog"
      width="520px"
    >
      <el-form
        :rules="rules"
        ref="editTagsGroupForm"
        :model="editTagsGroupForm"
      >
        <el-form-item
          label="分组名称:"
          :label-width="addLabelWidth"
          prop="name"
        >
          <el-input
            :maxlength="20"
            type="text"
            v-model.trim="editTagsGroupForm.name"
            auto-complete="off"
            placeholder="输入标签分组名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
        style="margin-top: 10px"
      >
        <el-button
          class="dialog-cancel-btn"
          @click="editTagsGroupDialog = false"
          style="margin-left: 20px"
        >取 消</el-button>
        <el-button
          :disabled="btnDisabled"
          class="dialog-confirm-btn"
          type="primary"
          @click="submitEditTagsGroup('editTagsGroupForm')"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { butonsList, getMenId } from '@/api/analyse.js'
import { getTagsGroupList, addTagsGroup, editTagsGroup, deleteTagsGroup, getTagsList, addTags, editTags, deleteTags, moveTagsGroup, getCusTypes } from '@/api/set.js'
export default {
  name: 'weixinManage',
  data () {
    return {
      editTagsDialog: false,
      modelData: [],
      changeGroupId: '',
      btnDisabled: false,
      editTagsGroupForm: {},
      editTagsGroupDialog: false,
      tagsName: '',
      modelId: '',
      addForm: {},
      addTagsGroupForm: {},
      addTagGroupDialog: false, // 添加标签分组
      tagsOptions: [],
      addTagDialog: false,
      loading: true,
      formInline: {},
      timePickerDate: '',
      imgpath: '',
      spreadurl: '',
      date: '',
      title: '',
      tableData: [],
      tags_group: '',
      showCustomer: true,
      limit: 10,
      totalCount: 0,
      editdialog: false,
      addTagsForm: {
        name: ''
      },
      editTagsForm: {
        name: '',
        groupId: ''
      },
      addLabelWidth: '80px',
      page: 1,
      hide: true,
      closeChoose: '收起筛选',
      searchForm: {
        admin_title: '',
        publish_status: '',
        start_time: '',
        end_time: '',
        group_id: ''
      },
      search: {
        admin_title: '',
        publish_status: '',
        start_time: '',
        end_time: '',
        group_id: ''
      },
      groupName: '',
      groups: [],
      queryGroups: [],
      deleteArrayIds: [],
      checkAll: true,
      createGroupType: 0,
      isDisabled: false,
      addTagRules: {
        name: [
          { required: true, message: '请输入标签名称', trigger: 'blur' }
        ]
      },
      rules: {
        name: [
          { required: true, message: '请输入标签分组名称', trigger: 'blur' }
        ]
      },
      butsObj: { // button按钮列表
        add_group: false,
        edit: false,
        del: false,
        add:false,
        edit_group: false,
        del_group: false,
        move_to_group: false
      }
    }
  },
  mounted () {
  },
  computed: {
    Newitems () {
      let _this = this
      let Newitems = []
      if (_this.groupName === '') {
        return
      }
      _this.groups.map(function (item) {
        if (item.name.search(_this.groupName) != -1) {
          Newitems.push(item)
        }
      })
      return Newitems
    }
  },
  components: {
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getAudiencesName(to.params.id, to)
    })
  },
  beforeRouteUpdate (to, from, next) {
    this.modelId = to.params.id
    this.loadTagsGroupList()
    this.getAudiencesName(to.params.id, to)
    this.loadTagList()
    next()
  },
  methods: {
    // 获取可用菜单按钮列表
    getButtonsList () {
      let params = {
        systemCode: 'ZY_INTELLIQUOR',
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId'),
        menuId: getMenId(this.$route.path)
      }
      butonsList(params).then(res=>{
        if (res.data.code === '200') {
          let result = res.data.result || []
          let arrObj = Object.keys(this.butsObj)
          let newarr  = result.map((item)=>{
            return item.perms
          })
          arrObj.map(it=> {
            if (newarr.indexOf(it)!==-1) {
              this.butsObj[it] = true
            } else {
              this.butsObj[it] = false
            }
          })
        }
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    // 获取列表名字
    getAudiencesName (modelId, to) {
      getCusTypes().then((res) => {
        if (res.data.code == 200) {
          this.modelData = res.data.result
          let id = this.$route.params.id
          for (let item of this.modelData) {
            if (item.id == id) {
              this.useName = item.name
              let arr = to.meta.routeArr
              arr[0].name = item.name + ''
              arr[1].name = item.name + '标签管理'
              this.$store.state.breadcrumb = to.meta.routeArr
            }
          }
        }
      })
    },
    pushToHightSearch (item) {
      if (item.useNum === 0) {
        return
      }
      let audQuery = {
        allRelationship: 'and',
        termsGroup: [{
          inOperator: 'and',
          terms: [{
            relationOptions: [
              {
                value: 'contain',
                label: '包含'
              },
              {
                value: 'not_contain',
                label: '不包含'
              },
              {
                value: 'empty',
                label: '为空'
              },
              {
                value: 'not_empty',
                label: '不为空'
              }
            ],
            attr: 'aud_portary',
            attr_label: '真实姓名',
            relationship: 'contain',
            value: item.name,
            selectedOptions: ['aud_portary', 'tag@select'],
            secAttr: 'tag',
            type: 'select'
          }]
        }]
      }
      sessionStorage.removeItem('audQueryModelId')
      sessionStorage.removeItem('audQuery')
      sessionStorage.setItem('audQueryModelId', JSON.stringify(this.modelId))
      sessionStorage.setItem('audQuery', JSON.stringify(audQuery))
      let str = '/home/audiences-manage/' + this.modelId
      router.push({ path: str })
    },
    // 编辑标签
    editTagsItem (item) {
      console.log(item, 'vv')
      if (item.groupId !== 0) {
        this.editTagsForm.groupId = item.groupId
      }
      if (this.tagsOptions.length === 0) {
        this.editTagsForm.groupId = ''
      }
      let flag = 0
      this.tagsOptions.some(items => {
        if (items.id !== item.groupId) {
          flag++
        }
        if (flag === this.tagsOptions.length) {
          this.editTagsForm.groupId = ''
        }
      })
      this.editTagsForm.id = item.id
      this.editTagsForm.name = item.name
      this.editTagsDialog = true
    },
    // 选择不同分组
    chooseTagsType (index, item) {
      this.loading = true
      this.tagsName = ''
      this.changeGroupId = item.id
      this.page = 1
      this.loadTagList()
    },
    // 获取标签列表
    loadTagList () {
      let params = {
        limit: this.limit,
        page: this.page,
        modelId: this.modelId,
        name: this.tagsName,
        groupId: this.changeGroupId
      }
      getTagsList(params).then(res => {
        this.loading = false
        if (res.data.code === '200') {
          this.totalCount = res.data.result.total
          this.tableData = res.data.result.list
        }
      })
    },
    submitAddTagsGroupForm (formName) {
      if (this.btnDisabled === true) {
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmAddTagsGroup()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 创建标签分组
    confirmAddTagsGroup () {
      this.btnDisabled = true
      addTagsGroup(this.addTagsGroupForm.name, parseInt(this.modelId)).then(res => {
        setTimeout(() => {
          this.btnDisabled = false
        }, 1000)
        if (res.data.code === '200') {
          _g.toastMsg('success', res.data.message)
          this.addTagsGroupForm.name = ''
          this.addTagGroupDialog = false
          this.loadTagsGroupList()
        } else {
          _g.toastMsg('error', res.data.message)
        }
      })
    },
    // 编辑标签弹框
    submitEditTagsForm (formName) {
      if (this.btnDisabled === true) {
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmEditTags()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    confirmEditTags () {
      this.btnDisabled = true
      let editTagsDate = {
        name: this.editTagsForm.name,
        groupId: this.editTagsForm.groupId || 0,
        id:  this.editTagsForm.id,
        modelId: this.modelId
      }
      editTags(editTagsDate).then(res => {
        setTimeout(() => {
          this.btnDisabled = false
        }, 1000)
        if (res.data.code === '200') {
          this.editTagsDialog = false
          this.loadTagList()
          _g.toastMsg('success', res.data.message)
        } else {
          _g.toastMsg('error', res.data.message)
        }
      })
    },
    // 添加标签弹框
    submitAddTagsForm (formName) {
      if (this.btnDisabled === true) {
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmAddTags()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    confirmAddTags () {
      this.btnDisabled = true
      this.addTagsForm.modelId = this.modelId
      addTags(this.addTagsForm).then(res => {
        this.btnDisabled = false
        if (res.data.code === '200') {
          this.addTagDialog = false
          this.addTagsForm = {}
          this.loadTagList()
          _g.toastMsg('success', res.data.message)
        } else {
          _g.toastMsg('error', res.data.message)
        }
      })
    },
    searchLoad () {
      this.page = 1
      this.loadTagList()
    },
    // 查找标签类型
    searchQrcodeType () {
      for (let i in this.groups) {
        this.groups[i].choosen = false
        for (let j in this.Newitems) {
          if (this.groups[i].id === this.Newitems[j].id) {
            this.groups[i].choosen = true
          }
        }
      }
    },
    // 确认移到分组
    confirmChooseGroupType () {
      let params = {
        groupId: this.tags_group,
        ids: this.deleteArrayIds
      }
      moveTagsGroup(params).then((res) => {
        if (res.data.code === '200') {
          this.loadTagList()
          this.tags_group = ''
          _g.toastMsg('success', res.data.message)
        } else {
          _g.toastMsg('error', res.data.message)
        }
      })
    },
    // 全选
    handleSelectionChange (val) {
      this.deleteArrayIds = []
      for (let i in val) {
        this.deleteArrayIds.push(val[i].id)
      }
      if (parseInt(val.length) > 0) {
        if(this.butsObj.move_to_group) {
          this.checkAll = false
        } else {
          this.checkAll = true
        }
      } else {
        this.checkAll = true
      }
    },
    // 标签列表删除
    deleteTagsItem (item) {
      if (item.useNum !== 0) {
        this.$confirm('删除标签后客户中的标签会同步移除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteTags(item.id).then((res) => {
            if (res.data.code === '200') {
              this.loadTagList()
              _g.toastMsg('success', res.data.message)
            } else {
              _g.toastMsg('error', res.data.message)
            }
          })
        }).catch((error) => {
          console.log(error)
        })
      } else {
        this.$confirm('确认删除该标签?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteTags(item.id).then((res) => {
            if (res.data.code === '200') {
              this.loadTagList()
              _g.toastMsg('success', res.data.message)
            } else {
              _g.toastMsg('error', res.data.message)
            }
          })
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    // 处理分页
    handleSizeChange (val) {
      this.limit = val
    },
    handleCurrentChange (page) {
      this.page = page
      this.loading = true
      this.loadTagList()
    },
    // 数据加载时的动画
    openLoading () {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 加载标签分组列表
    loadTagsGroupList () {
      // let id = this.$route.params.id
      getTagsGroupList(this.modelId).then((res) => {
        if (res.data.code === '200') {
          this.queryGroups = JSON.parse(JSON.stringify(res.data.result))
          this.tagsOptions = JSON.parse(JSON.stringify(res.data.result))
          res.data.result.unshift({ id: '', name: '全部' })
          for (let item of res.data.result) {
            item.choosen = false
          }
          this.groups = JSON.parse(JSON.stringify(res.data.result))
        }
      })
    },
    // 左侧分组导航
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    // 收起筛选和展开筛选
    closeAndOpen () {
      if (this.hide === true) {
        this.closeChoose = '展开筛选'
        this.hide = false
      } else {
        this.closeChoose = '收起筛选'
        this.hide = true
      }
    },
    // 添加标签分组
    addGroup () {
      this.addTagGroupDialog = true
      this.addForm.name = ''
    },
    // 删除标签分组
    deleteTagsGroupItem (item) {
      let that = this
      this.$confirm('确认删除该标签分组?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteTagsGroup(item.id).then((res) => {
          if (res.data.code === '200') {
            that.searchForm.group_id = ''
            that.loadTagsGroupList()
            that.loadTagList()
            _g.toastMsg('success', res.data.message)
          } else {
            _g.toastMsg('error', res.data.message)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 编辑标签分组
    editGroupTypeItem (item) {
      this.editTagsGroupForm = JSON.parse(JSON.stringify(item))
      this.editTagsGroupDialog = true
    },
    submitEditTagsGroup (formName) {
      if (this.btnDisabled === true) {
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmTagsGroupEdit()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    confirmTagsGroupEdit () {
      this.btnDisabled = true
      this.editTagsGroupForm.modelId = parseInt(this.modelId)
      console.log(this.editTagsGroupForm)
      editTagsGroup(this.editTagsGroupForm).then((res) => {
        setTimeout(() => {
          this.btnDisabled = false
        }, 1000)
        if (res.data.code === '200') {
          this.loadTagsGroupList()
          _g.toastMsg('success', res.data.message)
          this.editTagsGroupDialog = false
        } else {
          _g.toastMsg('error', res.data.message)
        }
      })
    }
  },
  created () {
    this.modelId = this.$route.params.id
    this.loadTagList()
    this.loadTagsGroupList()
    this.getButtonsList()
  }
}
</script>

<style scoped>
.el-menu-item .menu-btn {
  display: none;
  float: right;
}
.el-menu-item:hover .menu-btn {
  display: block;
}
.cellDialog {
  text-align: left;
}
.getIt {
  color: #ff5500 !important;
}
.green {
  color: #05b324;
}
.red {
  color: #ff2b2b;
}
.cancelCreate {
  float: right;
  margin-right: 10px;
  color: #ff7373;
  cursor: pointer;
}
.el-menu-vertical-demo {
  position: relative;
}
.group-search {
  height: 60px;
  background: #fff;
  border-bottom: 1px solid #e5e5e5;
}
.el-radio-group {
  margin-top: -13px;
}
.text-align-left {
  text-align: left;
}
.text-align-right {
  text-align: right;
}
.table-title {
  text-align: left;
}
.el-input--prefix .el-input__inner {
  padding-left: 40px !important;
}
.group-manage {
  overflow-x: hidden;
}
.el-icon-circle-plus-outline {
  cursor: pointer;
}
.push-page {
  color: #1890ff;
  cursor: pointer;
}
</style>
